import { render, staticRenderFns } from "./WelcomeView.vue?vue&type=template&id=0be797bc&scoped=true"
import script from "./WelcomeView.vue?vue&type=script&lang=ts"
export * from "./WelcomeView.vue?vue&type=script&lang=ts"
import style0 from "./WelcomeView.vue?vue&type=style&index=0&id=0be797bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be797bc",
  null
  
)

export default component.exports